
import {getPlatformSysconfig} from "@/api/user/userCenter.js";
export async function handleLocalUrl() {
    let localUrl=sessionStorage.getItem("localUrl")
    if(!localUrl){
        let { result, openGatewayUrl} = await getPlatformSysconfig({});
        if(result == "000000",openGatewayUrl){
            sessionStorage.localUrl=openGatewayUrl;
            localUrl= openGatewayUrl;
        }
    }
    return localUrl;
  }